module.exports = __webpack_public_path__ + "img/39_18.d8a607ca.png";